const PERSISTENT_ITEMS_KEY = 'persistent-input';

export const build_store_key = (...values) =>
  values
    .map(String)
    .filter((v) => v.length > 0)
    .join(':');

export const get_stored_value = (key) => {
  if (key) {
    const raw_items = localStorage.getItem(PERSISTENT_ITEMS_KEY) || JSON.stringify({});
    try {
      const items = JSON.parse(raw_items);
      return items[key];
    } catch {
      return undefined;
    }
  }
  return undefined;
};

export const set_stored_value = (key, v) => {
  if (key) {
    const raw_items = localStorage.getItem(PERSISTENT_ITEMS_KEY) || JSON.stringify({});
    try {
      const items = JSON.parse(raw_items);
      localStorage.setItem(
        PERSISTENT_ITEMS_KEY,
        JSON.stringify({
          ...items,
          [key]: v,
        })
      );
    } catch {
      // EMPTY
    }
  }
};
